import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative text-center mb-6" }
const _hoisted_2 = { class: "d-flex gap-2 mt-2" }
const _hoisted_3 = {
  key: 2,
  class: "d-flex gap-2 mb-4"
}

import { ref, computed } from 'vue';
import { useAuthStore } from '@/store/auth';
import { useUsersStore } from '@/store/users';
import { useFileUploadStore } from '@/store/fileUpload';
import { useAlertStore } from '@/store/alertStore';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const authStore = useAuthStore();
const usersStore = useUsersStore();
const fileUploadStore = useFileUploadStore();
const alertStore = useAlertStore();
const router = useRouter();

const user = computed(() => authStore.user || {});
const editMode = ref(false);
const editPassword = ref(false);
const showPassword = ref(false);

const form = ref({
  name: user.value.name || '',
  email: user.value.email || '',
  profile_photo_path: user.value.profile_photo_path || '',
});
const password = ref({ new: '', confirm: '' });

const avatarPreview = ref(form.value.profile_photo_path);
const avatarLoading = ref(false);

const fileInput = ref<HTMLInputElement | null>(null);

function triggerFile() {
  (fileInput.value as HTMLInputElement).click();
}

async function onAvatarChange(e: Event) {
  const file = (e.target as HTMLInputElement).files?.[0];
  if (!file) return;
  avatarLoading.value = true;

  // Preview inmediato (opcional)
  const reader = new FileReader();
  reader.onload = (event) => {
    avatarPreview.value = event.target?.result as string;
  };
  reader.readAsDataURL(file);

  try {
    // 1. Sube el archivo con tu store de archivos
    const url = await fileUploadStore.uploadFile('users', file);
    // 2. Actualiza el usuario con la nueva foto
    await usersStore.updateUser(user.value.id, { profile_photo_path: url });
    // 3. Actualiza en authStore (por si lo usas en la barra)
    authStore.user.profile_photo_path = url;
    form.value.profile_photo_path = url;
    avatarPreview.value = url;
    alertStore.showAlert('Foto de perfil actualizada', 'success');
  } catch (error) {
    alertStore.showAlert('Ocurrió un error al subir la foto', 'error');
    avatarPreview.value = user.value.profile_photo_path;
  } finally {
    avatarLoading.value = false;
  }
}

function removeAvatar() {
  avatarPreview.value = '';
  form.value.profile_photo_path = '';
  usersStore.updateUser(user.value.id, { profile_photo_path: '' });
  authStore.user.profile_photo_path = '';
  alertStore.showAlert('Foto eliminada', 'success');
}

function saveProfile() {
  usersStore.updateUser(user.value.id, { ...form.value });
  editMode.value = false;
  alertStore.showAlert('Perfil actualizado', 'success');
}
function savePassword() {
  if (password.value.new !== password.value.confirm) {
    alertStore.showAlert('Las contraseñas no coinciden', 'error');
    return;
  }
  usersStore.updatePassword(user.value.id, password.value.new);
  editPassword.value = false;
  password.value.new = '';
  password.value.confirm = '';
}
function cancelEdit() {
  form.value.name = user.value.name;
  form.value.email = user.value.email;
  avatarPreview.value = user.value.profile_photo_path;
  editMode.value = false;
}
function logout() {
  authStore.logout();
  router.push({ name: 'Login' });
}

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "d-flex justify-center align-center",
    style: {"min-height":"90vh"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "rounded-3xl shadow-xl px-8 py-8",
        "max-width": "430"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_avatar, {
              size: "100",
              class: "mx-auto mb-2 avatar-uploader",
              color: "primary",
              style: {"font-size":"50px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(user.value?.name?.slice(0,1)), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_row, { class: "flex items-center justify-center gap-2 mb-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(form.value.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "ma-0 justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_subtitle, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(form.value.email), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "ma-0 justify-center mt-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_chip, {
                size: "x-small",
                class: "mb-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(user.value.role), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!editPassword.value)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "flex justify-center gap-2 mb-2"
              }))
            : (_openBlock(), _createBlock(_component_v_form, {
                key: 1,
                onSubmit: _withModifiers(savePassword, ["prevent"]),
                class: "fadein my-2",
                ref: "passwordForm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: password.value.new,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password.value.new) = $event)),
                    label: "Nueva contraseña",
                    type: showPassword.value ? 'text' : 'password',
                    "prepend-inner-icon": "mdi-lock",
                    density: "comfortable",
                    "append-inner-icon": showPassword.value ? 'mdi-eye-off' : 'mdi-eye',
                    "onClick:appendInner": _cache[1] || (_cache[1] = ($event: any) => (showPassword.value = !showPassword.value)),
                    required: "",
                    variant: "solo-filled"
                  }, null, 8, ["modelValue", "type", "append-inner-icon"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: password.value.confirm,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password.value.confirm) = $event)),
                    label: "Confirmar contraseña",
                    type: showPassword.value ? 'text' : 'password',
                    "prepend-inner-icon": "mdi-lock-check",
                    density: "comfortable",
                    required: "",
                    variant: "solo-filled"
                  }, null, 8, ["modelValue", "type"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      type: "submit",
                      variant: "text"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("Guardar")
                      ])),
                      _: 1,
                      __: [4]
                    }),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (editPassword.value = false))
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("Cancelar")
                      ])),
                      _: 1,
                      __: [5]
                    })
                  ])
                ]),
                _: 1
              }, 512)),
          _createVNode(_component_v_divider, { class: "my-4" }),
          (editMode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: saveProfile,
                  variant: "text"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("Guardar cambios")
                  ])),
                  _: 1,
                  __: [6]
                }),
                _createVNode(_component_v_btn, {
                  onClick: cancelEdit,
                  variant: "text"
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Cancelar")
                  ])),
                  _: 1,
                  __: [7]
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_btn, {
            block: "",
            color: "error",
            variant: "tonal",
            class: "mt-4",
            onClick: logout
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "mr-2" }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-logout")
                ])),
                _: 1,
                __: [8]
              }),
              _cache[9] || (_cache[9] = _createTextVNode(" Cerrar sesión "))
            ]),
            _: 1,
            __: [9]
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})